<template>
  <div class="tv">
    <template v-if="error">
      <div class="tv-cell">
        <p class="title-type">{{ error }}</p>
      </div>
      <div class="tv-cell button-list">
        <button v-if="canRetryUpload" class="text-button" @click="startUpload">{{ __('Retry') }}</button>
        <a v-if="download" role="button" class="text-button" :href="fileUrl" download>{{ __('Download') }}</a>
        <button class="text-button" @click="cancelUpload">{{ __('Cancel') }}</button>
      </div>
    </template>
    <template v-else>
      <div class="tv-cell">
        <OzLoadingSpinner />
      </div>
      <div class="tv-cell">
        <p class="title-type ellipsified-type">{{ finalTitle }}</p>
        <p class="caption-type">{{ __("Hang tight, we'll be done in a jiffy.") }}</p>
      </div>
      <div class="tv-cell">
        <button class="text-button" @click="cancelUpload">{{ __('Cancel') }}</button>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import OzLoadingSpinner from 'library/v4/components/OzLoadingSpinner.vue'
import UploadFileMixin from 'vuemixins/upload_file_mixin'

export default {
  components: { OzLoadingSpinner },
  mixins: [UploadFileMixin],
  props: {
    title: String,
    download: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    finalTitle() {
      if (this.title) {
        return this.title
      }
      return this.__('Uploading %{filename}', { filename: this.filename || this.__('file') })
    },
  },
}
</script>

<style scoped>
.button-list {
  justify-content: center;
}
</style>
